<template>
  <div class="about-container">
    <div class="about-content">
      <h1>关于 Xster 创意空间</h1>

      <section>
        <h2>我们的使命</h2>
        <p>
          Xster 创意空间是一个致力于提供创意工具和资源的平台。我们相信每个人都可以通过创意工具来表达自己的想法和创造力。
        </p>
      </section>

      <section>
        <h2>我们提供什么</h2>
        <p>我们的网站提供以下功能和服务：</p>
        <ul>
          <li><strong>颜色参考工具：</strong>提供丰富的颜色名称和十六进制代码，方便设计师和开发者快速查找和使用颜色。</li>
          <li><strong>Excel 数据生成器：</strong>帮助用户快速生成测试数据和示例数据。</li>
          <li><strong>HIIT 计时器：</strong>专业的间歇训练计时工具，支持自定义工作、休息和准备时间。</li>
          <li><strong>创意工具集合：</strong>不断更新和添加新的创意工具，满足不同用户的需求。</li>
        </ul>
      </section>

      <section>
        <h2>我们的价值观</h2>
        <ul>
          <li><strong>创新：</strong>我们不断探索新的创意和工具，为用户提供更好的体验。</li>
          <li><strong>实用：</strong>我们专注于提供真正有用的工具，解决实际问题。</li>
          <li><strong>开放：</strong>我们相信开放和分享能够促进创意和进步。</li>
          <li><strong>用户至上：</strong>用户体验是我们设计和开发的核心。</li>
        </ul>
      </section>

      <section>
        <h2>技术栈</h2>
        <p>
          本网站使用现代 Web 技术构建，包括 Vue.js、Element Plus 等，确保提供流畅、响应式的用户体验。
        </p>
      </section>

      <section>
        <h2>联系我们</h2>
        <p>
          如果您有任何问题、建议或反馈，欢迎通过
          <router-link to="/contact">联系页面</router-link>
          与我们取得联系。我们很乐意听到您的声音！
        </p>
      </section>

      <section>
        <h2>法律信息</h2>
        <p>
          请查看我们的
          <router-link to="/privacy">隐私政策</router-link>
          和
          <router-link to="/terms">使用条款</router-link>
          以了解更多信息。
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutPage",
};
</script>

<style scoped>
.about-container {
  position: relative;
  background: rgba(0, 68, 170, 0.3);
  overflow-y: auto;
  height: 80vh;
  padding: 20px;
  color: #f7f7f7;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.about-container::-webkit-scrollbar {
  display: none;
}

.about-content {
  max-width: 900px;
  margin: 0 auto;
  line-height: 1.8;
}

.about-content h1 {
  font-size: 2.5em;
  margin-bottom: 30px;
  color: #fff;
}

.about-content section {
  margin-bottom: 30px;
}

.about-content h2 {
  font-size: 1.5em;
  margin-top: 25px;
  margin-bottom: 15px;
  color: #fff;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
  padding-bottom: 5px;
}

.about-content p {
  margin-bottom: 15px;
  text-align: justify;
}

.about-content ul {
  margin-left: 20px;
  margin-bottom: 15px;
}

.about-content li {
  margin-bottom: 10px;
}

.about-content a {
  color: #66b3ff;
  text-decoration: underline;
}

.about-content a:hover {
  color: #99ccff;
}

@media (max-width: 768px) {
  .about-content {
    padding: 10px;
  }

  .about-content h1 {
    font-size: 2em;
  }

  .about-content h2 {
    font-size: 1.3em;
  }
}
</style>

